import React from 'react';
// @ts-ignore
// import { useSpring, animated } from 'react-spring';
import { Modal, Box, Button, Icon, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { setConsoleOpen, selectConsoleOpen, selectLogs, selectStartPosition, severityIcons, severityColors } from '../../services/redux/consoleSlice';
import OrbotnikIcon from '../common/Icons/Icons';
import { useAppDispatch, useAppSelector } from '../../services/redux/hooks';

export function LogModal() {
  const logs = useAppSelector(selectLogs);
  const dispatch = useAppDispatch();
  const open = useAppSelector(selectConsoleOpen); 
  const startPosition = useAppSelector(selectStartPosition) || {x:0,y:0}; 

  const handleClose = () => {
    dispatch(setConsoleOpen({consoleOpen:false}));
  };

//   useEffect(() => {
//     window.addEventListener('scroll', onScroll);
//     return () => {
//       window.removeEventListener('scroll', onScroll);
//     };
//   }, [logs]);

    // const animProps = useSpring({
    //     from: { transform: `translate3d(${startPosition.x-800}px, ${startPosition.y-100}px, 0) scale(0)` },
    //     to: { transform: `translate3d(${startPosition.x-400}px, ${startPosition.y}px, 0) scale(1)` },
    //     reset: true,
    //     config: { duration: 500 }, // Add configuration as needed
    // });


  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition

    >
      {/* <animated.div style={animProps}> */}
        <Box sx={{
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}
        >
          <Table>
            <TableBody>
              {logs.slice(0, 5).map(item => (
                <TableRow key={item.id}>
                  <TableCell>
                      <OrbotnikIcon iconName={severityIcons[item.severity] || "default-icon"} color={severityColors[item.severity] || "inherit"} />
                  </TableCell>
                  <TableCell>
                    {item.message}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => { /* Your remove action here */ }}>
                        <OrbotnikIcon iconName="Close" color="inherit" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Button onClick={handleClose}>Close</Button>
        </Box>
      {/* // </animated.div> */}
    </Modal>
  );
}

export default LogModal;